import type { FC } from "react";

import { TableCell } from "@/components/ui/table";
import { cn } from "@/lib/utils";

import { CustomBadge } from "../Badge";
import type { TablePropsBadge } from "./types";

const borderBottom = "border-b border-gray-200";

const TableCellBadge: FC<TablePropsBadge> = ({
  children,
  stage,
  classes,
  last = false,
  colSpan = 1,
}) => {
  return (
    <TableCell
      className={cn(
        "px-4 py-[16px] text-xs text-gray-950",
        classes,
        last && borderBottom
      )}
      colSpan={colSpan}
    >
      <CustomBadge variant={stage} size="xs">
        {children}
      </CustomBadge>
    </TableCell>
  );
};

export default TableCellBadge;
